import { formatDate, titleCase } from '../BusinessDetailReport/businessReportModel'
import { moreFromLexis } from './moreFromLexis'

const list = (value) => (Array.isArray(value) ? value : value ? [value] : [])
const text = (value) => (value == null || typeof value === 'object' ? '' : String(value)).trim()
const upper = (value) => text(value).toUpperCase()
const nameCase = (value) => titleCase(value).replace(/(^|\s)([a-z])(?=\s|$)/g, (m, space, letter) => space + letter.toUpperCase())
const records = (section) => {
    const value = section && typeof section === 'object' ? Object.values(section).find(Array.isArray) : null
    return (value || []).filter(r => r && typeof r === 'object')
}

const personLine = (p) => {
    const identity = list(p?.AKAs?.Identity)[0] || {}
    const name = nameCase([identity.Name?.First, identity.Name?.Middle, identity.Name?.Last].filter(Boolean).join(' '))
    if (!name) return ''
    const deceased = /^(Y|YES|TRUE)$/.test(upper(identity.Deceased)) || identity.DOD?.Year
    const age = Number(identity.Age) > 0 ? Number(identity.Age) : null
    return `${name}${deceased ? ' (deceased)' : age ? ` (${age})` : ''}`
}

export function buildPeople(person) {
    const relatives = [...new Set(records(person?.Relatives).map(personLine).filter(Boolean))]
    const associates = [...new Set(records(person?.Associates).map(personLine).filter(Boolean))]
    return { relatives, associates, hasData: relatives.length + associates.length > 0 }
}

export function buildSexOffenses(person) {
    return records(person?.SexualOffenses).map(s => {
        const convictions = list(s.Convictions?.Conviction).filter(Boolean)
        const first = convictions[0] || {}
        const minor = convictions.some(c => /^(Y|YES|TRUE)$/.test(upper(c.VictimIsMinor)))
        return {
            more: moreFromLexis(s, 'SexualOffenses/SexualOffense[]'),
            title: titleCase(first.OffenseDescription) || 'Sex offender registry record',
            facts: [first.ConvictionDate && `Convicted ${formatDate(first.ConvictionDate)}`, titleCase(s.StateOfOrigin) || s.OriginStateCode,
                titleCase(s.OffenderStatus)].filter(Boolean).join(' · '),
            chips: [
                { label: 'Registered sex offender', tone: 'declined' },
                (s.RiskDescription || s.RiskLevelCode) && { label: `Risk: ${titleCase(s.RiskDescription) || text(s.RiskLevelCode)}`, tone: 'declined' },
            ].filter(Boolean),
            details: [
                ['Status', titleCase(s.OffenderStatus)],
                ['Category', titleCase(s.OffenderCategory)],
                ['Risk level', [text(s.RiskLevelCode), titleCase(s.RiskDescription)].filter(Boolean).join(' · ')],
                ['Registration', [titleCase(s.Registration?.Type), formatDate(s.Registration?.Date1), titleCase(s.Registration?.County) && `${titleCase(s.Registration.County)} County`]
                    .filter(Boolean).join(' · ')],
                ['Victim was a minor', minor ? 'Yes' : ''],
                ['On the registry', [formatDate(s.DateFirstSeen), formatDate(s.DateLastSeen)].filter(Boolean).join(' to ')],
            ].filter(([, value]) => value).map(([label, value]) => ({ label, value })),
            blocks: convictions.length ? [{
                title: convictions.length > 1 ? `${convictions.length} convictions` : 'Conviction',
                details: convictions.map(c => ({ label: formatDate(c.ConvictionDate) || 'No date', value: [titleCase(c.OffenseDescription), text(c.OffenseCodeOrStatute),
                    titleCase(c.CourtName || c.ConvictionJurisdiction), titleCase(c.SentenceDescription)].filter(Boolean).join(' · ') })),
            }] : [],
        }
    })
}
